import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import type { ContextBackDestination } from '../../utils/uxNavigation';

type ContextBackButtonProps = {
  destination: ContextBackDestination;
  onBack: (destination: ContextBackDestination) => void;
  disabled?: boolean;
};

export function ContextBackButton({ destination, onBack, disabled = false }: ContextBackButtonProps) {
  return (
    <Button
      variant="outlined"
      startIcon={<ArrowBackIcon />}
      aria-label={`Back to ${destination.label}`}
      disabled={disabled}
      onClick={() => onBack(destination)}
      sx={{ alignSelf: 'flex-start', width: 'auto', maxWidth: '100%' }}
    >
      Back to {destination.label}
    </Button>
  );
}
